var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f7511c373f4ce9f3a0d8a7e1eda5962f595a221a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["phalaworld-next@phalaworldbackup"]={id:"f7511c373f4ce9f3a0d8a7e1eda5962f595a221a"};
      